import { ImportPartnerContactsRequestSchema, ImportPartnerContactsResponseSchema } from './import-partner-contacts.schema';
export const importPartnerContactsContract = {
    method: 'POST',
    path: '/api/v2/partner/contacts/import',
    description: "Add or update contacts on the rep's own call list from an imported sheet",
    requestSchema: ImportPartnerContactsRequestSchema,
    responseSchema: ImportPartnerContactsResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not a partner tenant member'
        }
    }
};

//# sourceMappingURL=import-partner-contacts.contract.js.map